import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

const PasswordInput = ({
    value,
    onChange,
    onBlur,
    placeholder,
    id,
    name,
    disabled = false,
    required = false,
    autoComplete,
    hasError = false,
    leadingIcon: LeadingIcon = null,
    className = "",
    inputClassName = "",
    ...inputProps
}) => {
    const [isVisible, setIsVisible] = useState(false);

    const defaultInputClassName = `w-full rounded-xl border bg-white py-3 pr-11 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100 ${
        LeadingIcon ? "pl-10" : "pl-3"
    } ${hasError ? "border-red-400" : "border-slate-200"}`;

    return (
        <div className={`relative ${className}`}>
            {LeadingIcon && (
                <LeadingIcon
                    size={18}
                    className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
                    aria-hidden="true"
                />
            )}
            <input
                {...inputProps}
                id={id}
                name={name}
                type={isVisible ? "text" : "password"}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                placeholder={placeholder}
                disabled={disabled}
                required={required}
                autoComplete={autoComplete}
                aria-invalid={inputProps["aria-invalid"] ?? hasError}
                className={inputClassName || defaultInputClassName}
            />
            <button
                type="button"
                onClick={() => setIsVisible((currentValue) => !currentValue)}
                disabled={disabled}
                className="absolute right-2 top-1/2 inline-flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-lg text-slate-500 transition hover:bg-slate-100 hover:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-100 disabled:cursor-not-allowed disabled:opacity-60"
                aria-label={isVisible ? "Hide password" : "Show password"}
            >
                {isVisible ? (
                    <EyeOff size={16} aria-hidden="true" />
                ) : (
                    <Eye size={16} aria-hidden="true" />
                )}
            </button>
        </div>
    );
};

export default PasswordInput;
